import { ConceptSections } from '../enums';

export const sectionState = {
  [ConceptSections.CONFIGURATIONS]: true,
  [ConceptSections.COMPONENT]: true,
  [ConceptSections.ARCHITECTURE]: false,
  [ConceptSections.REQUIREMENT]: false,
};
